import { useState, useEffect, useRef } from "react";

const SHEETS_URL = "https://script.google.com/macros/s/AKfycbw6-WpiG2-nt1x_HRkxAsIhVwQ4uykV5X1ZoG_xNa9dtEf00Vp9jAb3wLB7IGMaD6Sipg/exec";
const FA_SHOP_SHEETS_URL = "https://script.google.com/macros/s/AKfycbym-k8_WBf8Gwi61JgmgG9fyJgDv5Zxc-8hXv67_hxuEViURjNP-EjZwDylI4K_xF2L/exec";
const FA_PREORDER_SHEETS_URL = "https://script.google.com/macros/s/AKfycbzUdOlP6USoikLzjljRKC9jTBfX6gCY6VEGVDDqcULNOP3RTc802lghQAoMHQhqYAKAVw/exec";

/* ─── DATA ─────────────────────────────────────────────────────────── */
const PRODUCTS = [
  { type: "GW",       label: "Genius Weft" },
  { type: "VGW",      label: "Volume Genius Weft" },
  { type: "MW",       label: "Machine Weft" },
  { type: "VW",       label: "Volume Weft" },
  { type: "K Tips",   label: "K Tips" },
  { type: "I Tips",   label: "I Tips" },
  { type: "Tape Ins", label: "Tape Ins" },
  { type: "Topper",   label: "Topper" },
];
const LENGTHS   = ["16\"","18\"","20\"","22\"","24\""];
const TOPPER_LENGTHS = ["12\""];
const DENSITIES = [{ value:"35%", label:"35% Density" }];
const COLORS = [
  // ── Devotion Solid Shades ──
  { code:"#1",              name:"Oreo Crumble",          group:"Devotion", subgroup:"Solid" },
  { code:"#1b",             name:"Dark Chocolate",         group:"Devotion", subgroup:"Solid" },
  { code:"#2",              name:"Cocoa Bean",             group:"Devotion", subgroup:"Solid" },
  { code:"#4",              name:"Brownie Batter",         group:"Devotion", subgroup:"Solid" },
  { code:"#5",              name:"Maple Pecan",            group:"Devotion", subgroup:"Solid" },
  { code:"#6",              name:"Chocolate Mousse",       group:"Devotion", subgroup:"Solid" },
  { code:"#8",              name:"Milk Chocolate",         group:"Devotion", subgroup:"Solid" },
  { code:"#14",             name:"Brown Butter Blondie",   group:"Devotion", subgroup:"Solid" },
  { code:"#18a",            name:"Cookies & Cream",        group:"Devotion", subgroup:"Solid" },
  { code:"#22",             name:"Crème Brûlée",           group:"Devotion", subgroup:"Solid" },
  { code:"#24",             name:"Baklava",                group:"Devotion", subgroup:"Solid" },
  { code:"#27",             name:"Toffee Candy",           group:"Devotion", subgroup:"Solid" },
  { code:"#30",             name:"Carrot Cake",            group:"Devotion", subgroup:"Solid" },
  { code:"#33",             name:"Red Velvet Cupcake",     group:"Devotion", subgroup:"Solid" },
  { code:"#60",             name:"Sugar Cookie",           group:"Devotion", subgroup:"Solid" },
  { code:"#60a",            name:"Coconut Frosting",       group:"Devotion", subgroup:"Solid" },
  { code:"#99J",            name:"BlackBerry Pie",         group:"Devotion", subgroup:"Solid" },
  { code:"#530",            name:"Raspberry Drizzle",      group:"Devotion", subgroup:"Solid" },
  { code:"#613",            name:"Cheesecake",             group:"Devotion", subgroup:"Solid" },
  { code:"#Silver",         name:"Iced Cookie",            group:"Devotion", subgroup:"Solid" },
  // ── Devotion Dimensional Shades ──
  { code:"#1b-1b/4",        name:"Chocolate Eclair",       group:"Devotion", subgroup:"Dimensional" },
  { code:"#2-M1B/Silver/18A/9A", name:"Tiramisu",          group:"Devotion", subgroup:"Dimensional" },
  { code:"#2-2/8",          name:"Mocha Frappe",           group:"Devotion", subgroup:"Dimensional" },
  { code:"#2-2/8/60",       name:"Maple Bar",              group:"Devotion", subgroup:"Dimensional" },
  { code:"#5-4/27",         name:"Peanut Butter Cookie",   group:"Devotion", subgroup:"Dimensional" },
  { code:"#5-5/10",         name:"Cinnamon Swirl",         group:"Devotion", subgroup:"Dimensional" },
  { code:"#5-6/24",         name:"Rocky Road",             group:"Devotion", subgroup:"Dimensional" },
  { code:"#5-6/60A",        name:"Iced Espresso",          group:"Devotion", subgroup:"Dimensional" },
  { code:"#5-5/20/60A",     name:"Vanilla Bean Truffle",   group:"Devotion", subgroup:"Dimensional" },
  { code:"#5-8/22",         name:"Vanilla Frappe",         group:"Devotion", subgroup:"Dimensional" },
  { code:"#8-8/22/60",      name:"Waffle Cone",            group:"Devotion", subgroup:"Dimensional" },
  { code:"#8-22/60",        name:"Lemon Cake",             group:"Devotion", subgroup:"Dimensional" },
  { code:"#8-18/22",        name:"Salted Caramel",         group:"Devotion", subgroup:"Dimensional" },
  { code:"#8-18/613",       name:"Toasted Almond",         group:"Devotion", subgroup:"Dimensional" },
  { code:"#18A/60A/Silver", name:"Glazed Doughnut",        group:"Devotion", subgroup:"Dimensional" },
  { code:"#18A/60",         name:"Cookie Dough",           group:"Devotion", subgroup:"Dimensional" },
  { code:"#8-18A/60",       name:"Cookie Dough",           group:"Devotion", subgroup:"Dimensional" },
  { code:"#5-18A/60",       name:"Cookie Dough",           group:"Devotion", subgroup:"Dimensional" },
  { code:"#4-18A/60",       name:"Cookie Dough",           group:"Devotion", subgroup:"Dimensional" },
  { code:"#8-18/60A",       name:"Pecan Sandies",          group:"Devotion", subgroup:"Dimensional" },
  { code:"#2-2/4/18a",      name:"Oreo Shake",             group:"Devotion", subgroup:"Dimensional" },
  // ── Faith & Allen Hair Co ──
  { code:"#1",                name:"Black Velvet",           group:"F&A" },
  { code:"#1A",               name:"Alter Ego",              group:"F&A" },
  { code:"#1b",               name:"The Bronzey Brunette",   group:"F&A" },
  { code:"#1B-1B/4",          name:"The Myrna",              group:"F&A" },
  { code:"#2",                name:"Diva",                   group:"F&A" },
  { code:"#2-2/6/60",         name:"The Faith",              group:"F&A" },
  { code:"#4",                name:"Bourbon Babe",           group:"F&A" },
  { code:"#4-2/8",            name:"Trophy Wife",            group:"F&A" },
  { code:"#4-2/60",           name:"Main Character",         group:"F&A" },
  { code:"#4-4/27",           name:"Golden Hour",            group:"F&A" },
  { code:"#4-5/10",           name:"Espresso Martini",       group:"F&A" },
  { code:"#4-6/24",           name:"Pure Gold",              group:"F&A" },
  { code:"#4-6/8/22",         name:"BOHO Bronde",            group:"F&A" },
  { code:"#4-6/60a",          name:"The Iconic (Logan)",     group:"F&A" },
  { code:"#4-8/60a",          name:"Old Money Blonde",       group:"F&A" },
  { code:"#4-18a/60",         name:"The Allen",              group:"F&A" },
  { code:"#4-18a/60a/silver", name:"Platinum VIP",           group:"F&A" },
  { code:"#4-60a",            name:"The Darling (Kenzie)",   group:"F&A" },
  { code:"#4-M4/20/60a",      name:"Champagne Toast",        group:"F&A" },
  { code:"#4-M613/60a",       name:"The Harper",             group:"F&A" },
  { code:"#5",                name:"The Boss",               group:"F&A" },
  { code:"#33",               name:"Red Velvet",             group:"F&A" },
  { code:"#99j",              name:"The Kenidi",             group:"F&A" },
  { code:"#B2-2/4/18a",       name:"The Elle",               group:"F&A" },
  { code:"#M14/60a",          name:"Southern Blonde",        group:"F&A" },
  { code:"#M27/613",          name:"The Emerson",            group:"F&A" },
  { code:"#M30/27",           name:"Spice Girl",             group:"F&A" },
  { code:"#M1B/S/18a/9a",     name:"Smokeshow",              group:"F&A" },
  { code:"#silver",           name:"Scandalous",             group:"F&A" },
];
const PRICING = {
  "GW":      {"16\"":{"35%":114},"18\"":{"35%":139},"20\"":{"35%":165},"22\"":{"35%":184},"24\"":{"35%":205}},
  "VGW":     {"16\"":{"35%":229},"18\"":{"35%":303},"20\"":{"35%":396},"22\"":{"35%":487},"24\"":{"35%":589}},
  "MW":      {"16\"":{"35%":177},"18\"":{"35%":220},"20\"":{"35%":262},"22\"":{"35%":294},"24\"":{"35%":327}},
  "VW":      {"16\"":{"35%":264},"18\"":{"35%":399},"20\"":{"35%":459},"22\"":{"35%":535},"24\"":{"35%":579}},
  "K Tips":  {"16\"":{"35%":181},"18\"":{"35%":225},"20\"":{"35%":267},"22\"":{"35%":298},"24\"":{"35%":331}},
  "I Tips":  {"16\"":{"35%":181},"18\"":{"35%":225},"20\"":{"35%":267},"22\"":{"35%":298},"24\"":{"35%":331}},
  "Tape Ins":{"16\"":{"35%":81}, "18\"":{"35%":123},"20\"":{"35%":144},"22\"":{"35%":160},"24\"":{"35%":178}},
  "Topper":  {"12\"":{"35%":250}},
};

const PRICING_50G = {
  "K Tips": {"16\"":{"35%":90.50},"18\"":{"35%":112.50},"20\"":{"35%":133.50},"22\"":{"35%":149},"24\"":{"35%":165.50}},
};

const VOLUME_PRICING = {
  "GW":      {"16\"":{"35%":109},"18\"":{"35%":132},"20\"":{"35%":158},"22\"":{"35%":177},"24\"":{"35%":198}},
  "VGW":     {"16\"":{"35%":220},"18\"":{"35%":295},"20\"":{"35%":385},"22\"":{"35%":475},"24\"":{"35%":572}},
  "MW":      {"16\"":{"35%":177},"18\"":{"35%":220},"20\"":{"35%":262},"22\"":{"35%":294},"24\"":{"35%":327}},
  "VW":      {"16\"":{"35%":255},"18\"":{"35%":389},"20\"":{"35%":449},"22\"":{"35%":525},"24\"":{"35%":569}},
  "K Tips":  {"16\"":{"35%":172},"18\"":{"35%":215},"20\"":{"35%":255},"22\"":{"35%":285},"24\"":{"35%":315}},
  "I Tips":  {"16\"":{"35%":181},"18\"":{"35%":225},"20\"":{"35%":267},"22\"":{"35%":298},"24\"":{"35%":331}},
  "Tape Ins":{"16\"":{"35%":81}, "18\"":{"35%":123},"20\"":{"35%":144},"22\"":{"35%":160},"24\"":{"35%":178}},
  "Topper":  {"12\"":{"35%":250}},
};

const VOLUME_PRICING_50G = {
  "K Tips": {"16\"":{"35%":86},"18\"":{"35%":107},"20\"":{"35%":127},"22\"":{"35%":142},"24\"":{"35%":157}},
};

const VOLUME_THRESHOLD = 15000;

// Grams per pack by product/length
const PACK_GRAMS = {
  "GW":      () => 60,
  "VGW":     (l) => ({'16"':120,'18"':130,'20"':145,'22"':160,'24"':175}[l] || 145),
  "MW":      () => 100,
  "VW":      () => 210,
  "K Tips":  (l, grams) => grams === "50g" ? 50 : 100,
  "I Tips":  () => 25,
  "Tape Ins":() => 50,
  "Topper":  () => 150,
};
const SHIPPING_RATE = 35; // per 500g

const FA_SHOP_PRICING = {
  "GW":      {'16"':{"35%":163},'18"':{"35%":198},'20"':{"35%":237},'22"':{"35%":265},'24"':{"35%":297}},
  "VGW":     {'16"':{"35%":330},'18"':{"35%":442},'20"':{"35%":577},'22"':{"35%":712},'24"':{"35%":858}},
  "MW":      {'16"':{"35%":265},'18"':{"35%":330},'20"':{"35%":393},'22"':{"35%":441},'24"':{"35%":490}},
  "VW":      {'16"':{"35%":382},'18"':{"35%":583},'20"':{"35%":673},'22"':{"35%":787},'24"':{"35%":853}},
  "K Tips":  {'16"':{"35%":258},'18"':{"35%":322},'20"':{"35%":382},'22"':{"35%":427},'24"':{"35%":472}},
  "I Tips":  {'16"':{"35%":258},'18"':{"35%":322},'20"':{"35%":382},'22"':{"35%":427},'24"':{"35%":472}},
  "Tape Ins":{'16"':{"35%":121},'18"':{"35%":184},'20"':{"35%":216},'22"':{"35%":240},'24"':{"35%":267}},
};

// 50g same price as 100g for FA shop
const FA_SHOP_PRICING_50G = {
  "K Tips": {'16"':{"35%":258},'18"':{"35%":322},'20"':{"35%":382},'22"':{"35%":427},'24"':{"35%":472}},
};

const FA_PREORDER_PRICING = {
  "Signature Weft": {"18\"":{"35%":276}, "22\"":{"35%":374}},
  "Legacy Weft":    {"18\"":{"35%":707}, "22\"":{"35%":1137}},
  "K Tips":         {"18\"":{"35%":129}, "22\"":{"35%":172}},
  "Clip Ins":            {"16\"":{"35%":227}, "18\"":{"35%":280}, "20\"":{"35%":381}, "22\"":{"35%":455}},
  "Curly Genius Weft":   {"18\"":{"35%":276}, "20\"":{"35%":336}, "22\"":{"35%":374}, "24\"":{"35%":416}},
};

const FA_PREORDER_PRODUCTS = [
  { type: "Clip Ins",          label: "Clip Ins" },
  { type: "Curly Genius Weft", label: "Curly Genius Weft" },
];

const FA_PREORDER_LENGTHS = ["18\"", "22\""];
const FA_PREORDER_LENGTHS_BY_TYPE = {
  "Clip Ins":          ["18\"", "22\""],
  "Curly Genius Weft": ["18\"", "22\""],
};

const FA_PREORDER_PACK_GRAMS = {
  "Signature Weft": () => 60,
  "Legacy Weft":    (l) => ({"18\"":130,"22\"":160}[l] || 130),
  "K Tips":         () => 25,
  "Clip Ins":          (l) => ({"16\"":130,"18\"":130,"20\"":150,"22\"":150}[l] || 130),
  "Curly Genius Weft": () => 50,
};

const getPrice = (t,l,d,grams,vol,faShop,faPreorder) => {
  if (faPreorder) return FA_PREORDER_PRICING[t]?.[l]?.[d] || null;
  if (faShop) {
    if (t === "K Tips" && grams === "50g") return FA_SHOP_PRICING_50G[t]?.[l]?.[d] || null;
    return FA_SHOP_PRICING[t]?.[l]?.[d] || null;
  }
  if (t === "K Tips" && grams === "50g") {
    return vol ? (VOLUME_PRICING_50G[t]?.[l]?.[d] || null) : (PRICING_50G[t]?.[l]?.[d] || null);
  }
  return vol ? (VOLUME_PRICING[t]?.[l]?.[d] || null) : (PRICING[t]?.[l]?.[d] || null);
};
const getAvailDensities = () => DENSITIES;

let _id = 1;
const uid = () => _id++;
const emptyCustomMix = () => ({ id:uid(), desc:"", qty:1 });
const emptyLine = () => ({ id:uid(), type:"", length:"", density:"35%", grams:"", selectedColors:[], colorQtys:{}, colorTexture:{}, customMixes:[], useCustom:false });

/* ─── PALETTE ───────────────────────────────────────────────────────── */
const C = {
  pageBg:      "#F5F5F5",
  white:       "#FFFFFF",
  headerBg:    "#0A0A0A",
  headerText:  "#FFFFFF",
  dark:        "#0A0A0A",
  mid:         "#333333",
  muted:       "#666666",
  border:      "#CCCCCC",
  accent:      "#6B46C1",
  accentLight: "#EDE9F7",
  accentMid:   "#C4B5E8",
};

const FONT = "Helvetica Neue, Helvetica, Arial, sans-serif";

/* ─── HELPERS ───────────────────────────────────────────────────────── */
const inp = (err) => ({
  padding:"10px 12px", border:`1.5px solid ${err ? "#DC2626" : C.border}`, borderRadius:4,
  background:err ? "#FFF5F5" : C.white, fontFamily:FONT, fontSize:15, color:C.dark,
  outline:"none", boxSizing:"border-box", width:"100%",
});
const sel = () => ({
  padding:"9px 28px 9px 10px", border:`1.5px solid ${C.border}`, borderRadius:4,
  background:C.white, fontFamily:FONT, fontSize:14, color:C.dark,
  cursor:"pointer", outline:"none", width:"100%", appearance:"none", WebkitAppearance:"none",
  backgroundImage:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23666' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' fill='none'/%3E%3C/svg%3E")`,
  backgroundRepeat:"no-repeat", backgroundPosition:"right 10px center",
});

/* ─── MAIN APP ──────────────────────────────────────────────────────── */
export default function App() {
  const _brand = typeof window !== "undefined" ? new URLSearchParams(window.location.search).get("brand") : "";
  const isFaithAndAllen = _brand === "faithandallen" || _brand === "faithandallenshop" || _brand === "faithandallenretail";
  const isFaithAndAllenShop = _brand === "faithandallenshop";
  const isFaithAndAllenRetail = _brand === "faithandallenretail";
  const [clientName,  setClientName]  = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientPhone, setClientPhone] = useState("");
  const [lines,       setLines]       = useState([emptyLine()]);
  const [submitted,   setSubmitted]   = useState(false);
  const [submitting,  setSubmitting]  = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [openDrop,    setOpenDrop]    = useState(null);
  const [mobileSheet, setMobileSheet] = useState(null);
  const [isMobile,    setIsMobile]    = useState(false);
  const dropRef = useRef(null);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 640);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => {
    const close = e => { if (dropRef.current && !dropRef.current.contains(e.target)) setOpenDrop(null); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  /* line/pack helpers */
  const updLine = (lid, field, val) => setLines(prev => prev.map(l => {
    if (l.id !== lid) return l;
    const u = { ...l, [field]: val };
    if (field === "type") {
      const avail = getAvailDensities(val);
      if (avail.length === 1) u.density = avail[0].value;
      else if (!avail.find(d => d.value === u.density)) u.density = "";
    }
    return u;
  }));

  const addLine = () => setLines(prev => [...prev, emptyLine()]);
  const remLine = lid => setLines(prev => prev.length>1 ? prev.filter(l=>l.id!==lid) : prev);
  const toggleColor = (lid, code) => setLines(prev => prev.map(l => {
    if (l.id !== lid) return l;
    const has = l.selectedColors.includes(code);
    const selectedColors = has ? l.selectedColors.filter(c=>c!==code) : [...l.selectedColors, code];
    const colorQtys = { ...l.colorQtys };
    if (!has && !colorQtys[code]) colorQtys[code] = 1;
    if (has) delete colorQtys[code];
    const colorTexture = { ...l.colorTexture };
    if (!has) colorTexture[code] = 'Straight';
    if (has) delete colorTexture[code];
    return { ...l, selectedColors, colorQtys, colorTexture };
  }));
  const setColorQty = (lid, code, qty) => setLines(prev => prev.map(l =>
    l.id !== lid ? l : { ...l, colorQtys: { ...l.colorQtys, [code]: qty } }
  ));
  const setColorTexture = (lid, code, texture) => setLines(prev => prev.map(l =>
    l.id !== lid ? l : { ...l, colorTexture: { ...l.colorTexture, [code]: texture } }
  ));

  const colorLabel = s => { const parts = s.split("|"); return parts.length>1 ? `${parts[0]} ${parts[1]}` : s; };
  const lineQtyTotal = l => l.useCustom
    ? l.customMixes.reduce((s,m)=>s+(parseInt(m.qty)||0),0)
    : Object.values(l.colorQtys).reduce((s,q)=>s+(parseInt(q)||0),0);
  const baseTotal = lines.reduce((s,l) => {
    const p = isFaithAndAllenRetail
      ? FA_PREORDER_PRICING[l.type]?.[l.length]?.["35%"] || 0
      : isFaithAndAllenShop
        ? (l.grams==="50g" ? FA_SHOP_PRICING_50G[l.type]?.[l.length]?.["35%"] : FA_SHOP_PRICING[l.type]?.[l.length]?.["35%"]) || 0
        : PRICING[l.type]?.[l.length]?.["35%"] || (l.grams==="50g" ? PRICING_50G[l.type]?.[l.length]?.["35%"] : null) || 0;
    return s + p * lineQtyTotal(l);
  }, 0);
  const isVolume = !isFaithAndAllenShop && !isFaithAndAllenRetail && baseTotal >= VOLUME_THRESHOLD;
  const lineTotal = l => { const p = getPrice(l.type,l.length,l.density,l.grams,isVolume,isFaithAndAllenShop,isFaithAndAllenRetail); return p ? p * lineQtyTotal(l) : 0; };
  const grandTotal = lines.reduce((s,l)=>s+lineTotal(l),0);
  const totalGrams = (!isFaithAndAllenShop) ? lines.reduce((s,l) => {
    const gramsPerPack = isFaithAndAllenRetail
      ? (FA_PREORDER_PACK_GRAMS[l.type] ? FA_PREORDER_PACK_GRAMS[l.type](l.length) : 0)
      : (PACK_GRAMS[l.type] ? PACK_GRAMS[l.type](l.length, l.grams) : 0);
    const qty = lineQtyTotal(l);
    return s + gramsPerPack * qty;
  }, 0) : 0;
  const estimatedShipping = (!isFaithAndAllenShop && !isFaithAndAllenRetail) ? Math.ceil(totalGrams / 500) * SHIPPING_RATE : 0;
  const totalPacks = lines.reduce((s,l)=>s+lineQtyTotal(l),0);
  const isLineValid = l => l.type && l.length && (l.type!=="K Tips" || l.grams) && (l.useCustom ? l.customMixes.length > 0 && l.customMixes.every(m=>m.desc.trim() && (parseInt(m.qty)||0)>0) : l.selectedColors.length > 0 && lineQtyTotal(l) > 0);
  const isValidEmail = v => /^[^\s@]+@[^\s@]+\.(com|ca|org|net|co|io|biz|edu|gov|info|me|us|uk|au|nz|ie|shop|store|online|studio|salon|beauty|hair)$/i.test(v.trim());
  const allValid = clientName.trim() && isValidEmail(clientEmail) && lines.every(isLineValid);

  const mobileLineData = mobileSheet ? lines.find(l=>l.id===mobileSheet.lineId) : null;

  /* SUBMIT */
  const handleSubmit = async () => {
    if (!allValid || submitting) return;
    setSubmitting(true);
    setSubmitError("");
    try {
      const orderLines = lines.map(l => ({
        product: isFaithAndAllenRetail
          ? (FA_PREORDER_PRODUCTS.find(p=>p.type===l.type)?.label || l.type)
          : `${(PRODUCTS.find(p=>p.type===l.type)?.label) || l.type} (${l.type})`,
        length: l.length,
        density: l.density,
        grams: l.grams || null,
        pricePerPack: getPrice(l.type, l.length, l.density, l.grams, isVolume, isFaithAndAllenShop, isFaithAndAllenRetail),
        packs: l.useCustom
          ? l.customMixes.map(m => ({ qty: parseInt(m.qty)||1, colour: m.desc }))
          : l.selectedColors.map(c => ({ qty: parseInt(l.colorQtys[c])||1, colour: colorLabel(c), texture: (l.type==="GW"||l.type==="VGW") ? (l.colorTexture[c]||"Straight") : null })),
      }));

      const payload = {
        clientName,
        email: clientEmail,
        phone: clientPhone,
        orderLines,
        grandTotal: grandTotal.toFixed(2),
        estimatedShipping: !isFaithAndAllenShop ? estimatedShipping.toFixed(2) : null,
      };

      await fetch(isFaithAndAllenRetail ? FA_PREORDER_SHEETS_URL : isFaithAndAllenShop ? FA_SHOP_SHEETS_URL : SHEETS_URL, {
        method: "POST",
        mode: "no-cors",
        body: JSON.stringify(payload),
      });

      // Create draft Square invoice
      if (!isFaithAndAllenRetail) {
        await fetch("/api/create-invoice", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ clientName, email: clientEmail, phone: clientPhone, orderLines, estimatedShipping: !isFaithAndAllenShop ? estimatedShipping : 0 }),
        });
      } else {
        await fetch("/api/create-invoice", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ clientName, email: clientEmail, phone: clientPhone, orderLines, estimatedShipping: 0, invoiceTitle: `Pre-Order — ${clientName}` }),
        });
      }

      setSubmitted(true);
      setSubmitError("");
    } catch (err) {
      setSubmitError("Error: " + err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const reset = () => { setSubmitted(false); setLines([emptyLine()]); setClientName(""); setClientEmail(""); setClientPhone(""); setSubmitError(""); };

  /* ── CONFIRMATION ── */
  if (submitted) return (
    <div style={{ minHeight:"100vh", background:C.pageBg, fontFamily:FONT, color:C.dark }}>
      <style>{css}</style>
      <Header total={0} mb={isMobile} faShop={isFaithAndAllenShop} faWholesale={isFaithAndAllen && !isFaithAndAllenShop} faPreorder={isFaithAndAllenRetail} />
      <div style={{ maxWidth:540, margin:"0 auto", padding:isMobile?"40px 16px 80px":"60px 24px 80px", textAlign:"center" }}>
        <div style={{ width:52, height:52, borderRadius:"50%", background:C.accentLight, border:`2px solid ${C.accentMid}`, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 20px", fontSize:22, color:C.accent }}>✓</div>
        <h2 style={{ fontSize:22, fontWeight:700, marginBottom:8 }}>Order Received</h2>
        <p style={{ fontSize:14, color:C.mid, marginBottom:24, lineHeight:1.6 }}>Thank you, <strong>{clientName}</strong>. We've logged your order and will be in touch at <strong>{clientEmail}</strong>.</p>
        <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:4, padding:"20px 22px", textAlign:"left" }}>
          {lines.map((l,i) => {
            const prod = PRODUCTS.find(p=>p.type===l.type);
            const price = getPrice(l.type,l.length,l.density,l.grams,isVolume,isFaithAndAllenShop);
            return (
              <div key={l.id}>
                <div style={{ fontSize:13, fontWeight:700, color:C.dark, marginBottom:4 }}>{l.length} {prod?.label}{l.grams ? ` · ${l.grams}` : ""} <span style={{ color:C.accent, fontWeight:400 }}>${price}/pack</span></div>
                {l.useCustom
                  ? l.customMixes.map(m => <div key={m.id} style={{ fontSize:12, color:C.mid, paddingLeft:10, marginBottom:2 }}>{m.qty||1}× {m.desc}</div>)
                  : l.selectedColors.map(c => <div key={c} style={{ fontSize:12, color:C.mid, paddingLeft:10, marginBottom:2 }}>{l.colorQtys[c]||1}× {colorLabel(c)}{(l.type==="GW"||l.type==="VGW") ? ` — ${l.colorTexture?.[c]||"Straight"}` : ""}</div>)}
                <div style={{ textAlign:"right", fontSize:12, color:C.mid }}>${lineTotal(l).toFixed(2)}</div>
                {i<lines.length-1 && <div style={{ height:1, background:C.border, margin:"10px 0" }}/>}
              </div>
            );
          })}
          <div style={{ display:"flex", justifyContent:"space-between", fontWeight:700, fontSize:14, borderTop:`2px solid ${C.dark}`, paddingTop:10, marginTop:8 }}>
            <span>Grand Total (USD)</span><span>${grandTotal.toFixed(2)}</span>
          </div>
        </div>
        <button className="btn-primary" style={{ marginTop:20, padding:"13px 0", width:isMobile?"100%":"200px", display:"inline-block" }} onClick={reset}>Place Another Order</button>
      </div>
    </div>
  );

  /* ── MAIN FORM ── */
  return (
    <div style={{ minHeight:"100vh", background:C.pageBg, fontFamily:FONT, color:C.dark, paddingBottom:isMobile?90:0 }}>
      <style>{css}</style>
      <Header total={grandTotal} mb={isMobile} faShop={isFaithAndAllenShop} faWholesale={isFaithAndAllen && !isFaithAndAllenShop} faPreorder={isFaithAndAllenRetail} />

      {isVolume && (
        <div style={{ background:"#6B46C1", color:"#fff", textAlign:"center", padding:"8px 16px", fontSize:11, letterSpacing:"0.12em", textTransform:"uppercase", position:"sticky", top:isMobile?49:54, zIndex:49 }}>
          🎉 Volume pricing applied — order over $15,000
        </div>
      )}

      <div style={{ maxWidth:800, margin:"0 auto", padding:isMobile?"18px 14px":"32px 24px 60px" }}>

        {/* 01 Client */}
        <Section num="01" title="Your Information">
          <div style={{ display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr 1fr", gap:14 }}>
            <Field label="Full Name" req><input style={inp()} placeholder="Jane Smith" value={clientName} onChange={e=>setClientName(e.target.value)} /></Field>
            <Field label="Email" req><input style={inp(clientEmail && !isValidEmail(clientEmail))} type="email" placeholder="jane@salon.com" value={clientEmail} onChange={e=>setClientEmail(e.target.value)} /></Field>
            <Field label="Phone"><input style={inp()} type="tel" placeholder="Optional" value={clientPhone} onChange={e=>setClientPhone(e.target.value)} /></Field>
          </div>
        </Section>

        <hr style={{ border:"none", borderTop:`1px solid ${C.border}`, margin:"24px 0" }}/>

        {/* 02 Order Items */}
        <Section num="02" title="Order Items" note={isMobile?undefined:"One row per product"}>
          {lines.map((line, li) => {
            const price = getPrice(line.type, line.length, line.density, line.grams, isVolume, isFaithAndAllenShop, isFaithAndAllenRetail);
            const lTotal = lineTotal(line);
            return (
              <div key={line.id} style={{ background:C.white, border:`1.5px solid ${C.border}`, borderRadius:4, marginBottom:10 }}>
                {/* Selector row */}
                <div style={{ padding:"10px 14px", borderBottom:`1px solid ${C.border}`, background:"#FAFAFA", display:"flex", alignItems:"center", gap:10, flexWrap:isMobile?"wrap":"nowrap" }}>
                  <span style={{ fontSize:11, color:C.muted, fontWeight:600, minWidth:24 }}>#{li+1}</span>
                  <div style={{ flex:isMobile?"1 1 calc(50% - 22px)":"1 1 0" }}>
                    <select style={sel()} value={line.type} onChange={e=>{ const t=e.target.value; setLines(prev=>prev.map(l=>l.id!==line.id?l:{...l,type:t,length:t==="Topper"?"12\"":l.length==="12\""?"":l.length,grams:""})); }}>
                      <option value="">Product—</option>
                      {(isFaithAndAllenRetail ? FA_PREORDER_PRODUCTS : PRODUCTS).map(p=><option key={p.type} value={p.type}>{isMobile?p.type:`${p.label} (${p.type})`}</option>)}
                    </select>
                  </div>
                  <div style={{ flex:isMobile?"1 1 calc(50% - 22px)":"0 0 88px" }}>
                    <select style={sel()} value={line.length} onChange={e=>updLine(line.id,"length",e.target.value)}>
                      <option value="">Length—</option>
                      {(isFaithAndAllenRetail ? (FA_PREORDER_LENGTHS_BY_TYPE[line.type] || FA_PREORDER_LENGTHS) : line.type==="Topper" ? TOPPER_LENGTHS : LENGTHS).map(l=><option key={l} value={l}>{l}</option>)}
                    </select>
                  </div>
                  {false && (
                  <div style={{ flex:isMobile?"1 1 calc(50% - 22px)":"0 0 130px" }}>
                    <select style={sel()} value={line.density} onChange={e=>updLine(line.id,"density",e.target.value)}>
                      <option value="">Density—</option>
                      {DENSITIES.map(d=><option key={d.value} value={d.value}>{d.label}</option>)}
                    </select>
                  </div>
                  )}
                  {line.type==="K Tips" && (
                    <div style={{ flex:isMobile?"1 1 calc(50% - 22px)":"0 0 100px" }}>
                      <select style={sel()} value={line.grams} onChange={e=>updLine(line.id,"grams",e.target.value)}>
                        <option value="">Grams—</option>
                        <option value="50g">50g</option>
                        <option value="100g">100g</option>
                      </select>
                    </div>
                  )}
                  <div style={{ flex:"0 0 auto", display:"flex", alignItems:"center", gap:8, marginLeft:"auto" }}>
                    {price && <span style={{ fontSize:13, color:C.mid, whiteSpace:"nowrap" }}><span style={{ color:C.accent, fontWeight:700 }}>${price}</span>/pk{lTotal>0&&<span style={{ fontWeight:700, color:C.dark }}> · ${lTotal.toFixed(2)}</span>}</span>}
                    {lines.length>1 && <button className="btn-icon" onClick={()=>remLine(line.id)}>✕</button>}
                  </div>
                </div>

                {/* Colours */}
                <div style={{ padding:"10px 14px" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                    <div style={{ fontSize:11, textTransform:"uppercase", letterSpacing:"0.08em", color:C.muted }}>Colours</div>
                    <div style={{ display:"flex", border:`1.5px solid ${C.border}`, borderRadius:3, overflow:"hidden", marginLeft:"auto" }}>
                      {[["select","Choose Shade"],["custom","Custom Mix"]].map(([mode,label])=>(
                        <button key={mode} onClick={()=>updLine(line.id,"useCustom",mode==="custom")}
                          style={{ padding:isMobile?"9px 8px":"6px 10px", fontSize:11, border:"none", cursor:"pointer", fontFamily:FONT, whiteSpace:"nowrap", background:((mode==="custom"&&line.useCustom)||(mode==="select"&&!line.useCustom))?C.dark:C.white, color:((mode==="custom"&&line.useCustom)||(mode==="select"&&!line.useCustom))?C.white:C.muted, transition:"all 0.15s" }}>
                          {label}
                        </button>
                      ))}
                    </div>
                  </div>

                  {!line.useCustom ? (<>
                    {isMobile ? (
                      <button onClick={()=>setMobileSheet({lineId:line.id, packId:"main"})}
                        style={{ width:"100%", padding:"10px 12px", border:`1.5px solid ${line.selectedColors.length?C.accent:C.border}`, borderRadius:3, background:line.selectedColors.length?C.accentLight:C.white, fontFamily:FONT, textAlign:"left", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
                        <span style={{ fontSize:12, color:line.selectedColors.length?C.accent:C.muted }}>{line.selectedColors.length?`${line.selectedColors.length} colour${line.selectedColors.length!==1?"s":""} selected`:"Tap to choose shades…"}</span>
                        <span style={{ color:C.muted }}>›</span>
                      </button>
                    ) : (
                      <div style={{ position:"relative", marginBottom:8 }} ref={openDrop===line.id?dropRef:null}>
                        <button onClick={()=>setOpenDrop(openDrop===line.id?null:line.id)}
                          style={{ display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%", padding:"7px 10px", border:`1.5px solid ${openDrop===line.id?C.accent:line.selectedColors.length?C.accentMid:C.border}`, borderRadius:3, background:line.selectedColors.length?C.accentLight:C.white, cursor:"pointer", fontFamily:FONT }}>
                          <span style={{ fontSize:12, color:line.selectedColors.length?C.accent:C.muted }}>{line.selectedColors.length?`${line.selectedColors.length} colour${line.selectedColors.length!==1?"s":""} selected`:"Select colour(s)…"}</span>
                          <span style={{ color:C.muted, transform:openDrop===line.id?"rotate(180deg)":"none", transition:"transform 0.2s", display:"inline-block" }}>▾</span>
                        </button>
                        {openDrop===line.id && (
                          <div style={{ position:"absolute", top:"calc(100% + 3px)", left:0, right:0, zIndex:200, background:C.white, border:`1.5px solid ${C.border}`, borderRadius:4, boxShadow:"0 6px 20px rgba(0,0,0,0.1)", padding:"10px 12px", maxHeight:260, overflowY:"auto" }} ref={dropRef}>
                            <ColorGrid colors={isFaithAndAllen ? COLORS.filter(c => c.group === "F&A") : COLORS.filter(c => c.group === "Devotion")} selected={line.selectedColors} onToggle={code=>toggleColor(line.id,code)} onClear={()=>updLine(line.id,"selectedColors",[])}/>
                          </div>
                        )}
                      </div>
                    )}
                    {line.selectedColors.length > 0 && (
                      <div style={{ display:"flex", flexDirection:"column", gap:6, marginTop:4 }}>
                        {line.selectedColors.map(c => {
                          const cQty = parseInt(line.colorQtys[c])||1;
                          const cTotal = price ? (price * cQty).toFixed(2) : null;
                          const showTexture = line.type === "GW" || line.type === "VGW";
                          const texture = line.colorTexture?.[c] || "Straight";
                          return (
                          <div key={c} style={{ display:"flex", alignItems:"center", gap:8, padding:"6px 8px", background:C.accentLight, borderRadius:3, flexWrap:isMobile?"wrap":"nowrap" }}>
                            <input type="number" min="1" value={line.colorQtys[c]||1} onChange={e=>setColorQty(line.id,c,e.target.value)}
                              style={{ width:isMobile?50:44, padding:isMobile?"8px 4px":"5px 4px", border:`1.5px solid ${C.border}`, borderRadius:3, fontFamily:FONT, fontSize:isMobile?16:13, color:C.dark, textAlign:"center", outline:"none", flexShrink:0 }}/>
                            <span style={{ fontSize:12, color:C.accent, fontWeight:600, flex:1 }}>{colorLabel(c)}</span>
                            {showTexture && (
                              <div style={{ display:"flex", border:`1.5px solid ${C.border}`, borderRadius:3, overflow:"hidden", flexShrink:0 }}>
                                {["Straight","Curly"].map(t => (
                                  <button key={t} onClick={()=>setColorTexture(line.id,c,t)}
                                    style={{ padding:isMobile?"7px 10px":"4px 10px", fontSize:11, border:"none", cursor:"pointer", fontFamily:FONT, background:texture===t?C.dark:C.white, color:texture===t?C.white:C.muted, transition:"all 0.15s", whiteSpace:"nowrap" }}>
                                    {t}
                                  </button>
                                ))}
                              </div>
                            )}
                            {cTotal && <span style={{ fontSize:11, color:C.muted, whiteSpace:"nowrap" }}>${price} × {cQty} = <strong style={{ color:C.dark }}>${cTotal}</strong></span>}
                            <button style={{ background:"none", border:"none", cursor:"pointer", color:C.muted, fontSize:14, marginLeft:"auto" }} onClick={()=>toggleColor(line.id,c)}>✕</button>
                          </div>
                          );
                        })}
                      </div>
                    )}
                  </>) : (<>
                    {line.customMixes.length > 0 && (
                      <div style={{ display:"flex", flexDirection:"column", gap:6, marginBottom:8 }}>
                        {line.customMixes.map((mix, mi) => (
                          <div key={mix.id} style={{ display:"flex", alignItems:"center", gap:8, padding:"6px 8px", background:C.accentLight, borderRadius:3 }}>
                            <span style={{ fontSize:11, color:C.muted, minWidth:60, fontWeight:600 }}>Mix {mi+1}</span>
                            <input type="number" min="1" value={mix.qty} onChange={e=>updLine(line.id,"customMixes",line.customMixes.map(m=>m.id===mix.id?{...m,qty:e.target.value}:m))}
                              style={{ width:isMobile?50:44, padding:isMobile?"8px 4px":"5px 4px", border:`1.5px solid ${C.border}`, borderRadius:3, fontFamily:FONT, fontSize:isMobile?16:13, color:C.dark, textAlign:"center", outline:"none" }}/>
                            <input placeholder="e.g. 4/6/20 or describe mix" value={mix.desc} onChange={e=>updLine(line.id,"customMixes",line.customMixes.map(m=>m.id===mix.id?{...m,desc:e.target.value}:m))}
                              style={{ flex:1, padding:isMobile?"10px 8px":"6px 8px", border:`1.5px solid ${C.border}`, borderRadius:3, fontFamily:FONT, fontSize:isMobile?14:12, color:C.dark, outline:"none" }}/>
                            <button style={{ background:"none", border:"none", cursor:"pointer", color:C.muted, fontSize:14 }} onClick={()=>updLine(line.id,"customMixes",line.customMixes.filter(m=>m.id!==mix.id))}>✕</button>
                          </div>
                        ))}
                      </div>
                    )}
                    <button className="btn-ghost" style={{ width:isMobile?"100%":"auto", padding:isMobile?"9px 0":"5px 12px" }}
                      onClick={()=>updLine(line.id,"customMixes",[...line.customMixes, emptyCustomMix()])}>
                      + Add Custom Mix
                    </button>
                  </>)}
                </div>
              </div>
            );
          })}
          <button className="btn-ghost" style={{ width:"100%", padding:isMobile?"12px":"9px", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }} onClick={addLine}>
            <span style={{ fontSize:16 }}>+</span> Add Product Line
          </button>
        </Section>



        {/* Desktop submit */}
        {!isMobile && (
          <>
            <hr style={{ border:"none", borderTop:`1px solid ${C.border}`, margin:"24px 0" }}/>
            <div style={{ display:"flex", alignItems:"flex-end", justifyContent:"space-between", gap:24 }}>
              <div>
                <div style={{ fontSize:11, color:C.muted, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:4 }}>{lines.length} line{lines.length!==1?"s":""} · {totalPacks} pack{totalPacks!==1?"s":""}</div>
                <div style={{ fontSize:34, fontWeight:700, letterSpacing:"-0.02em" }}>${grandTotal.toFixed(2)} <span style={{ fontSize:16, fontWeight:400, color:"#999" }}>USD</span></div>
                {!isFaithAndAllenShop && estimatedShipping > 0 && (
                  <div style={{ fontSize:11, color:C.muted, marginTop:4 }}>Est. shipping: <strong style={{ color:C.dark }}>${estimatedShipping.toFixed(2)}</strong> <span style={{ fontSize:10 }}>({totalGrams}g)</span></div>
                )}
              </div>
              <div style={{ flex:1, maxWidth:300 }}>
                {submitError && <p style={{ fontSize:12, color:"#c0392b", marginBottom:8 }}>{submitError}</p>}
                {!allValid && <p style={{ fontSize:11, color:C.muted, marginBottom:8, lineHeight:1.6 }}>Complete all fields including product, length and at least one colour per pack.</p>}
                <button className="btn-primary" style={{ width:"100%", padding:"13px", opacity:allValid?1:0.4, cursor:allValid?"pointer":"not-allowed" }} disabled={!allValid||submitting} onClick={handleSubmit}>
                  {submitting?"Submitting…":"Submit Order"}
                </button>
              </div>
            </div>
            <div style={{ textAlign:"center", marginTop:40, paddingBottom:20 }}>
              <span style={{ fontSize:9, letterSpacing:"0.28em", color:C.muted }}>DEVOTION SUPPLY CO. · WHOLESALE PORTAL</span>
            </div>
          </>
        )}
      </div>

      {/* Mobile footer */}
      {isMobile && (
        <div style={{ position:"fixed", bottom:0, left:0, right:0, background:C.white, borderTop:`1px solid ${C.border}`, padding:"10px 14px", display:"flex", gap:12, alignItems:"center", boxShadow:"0 -2px 10px rgba(0,0,0,0.07)", zIndex:40 }}>
          <div>
            <div style={{ fontSize:9, color:C.muted, textTransform:"uppercase", letterSpacing:"0.1em" }}>{totalPacks} pack{totalPacks!==1?"s":""}</div>
            <div style={{ fontSize:18, fontWeight:700 }}>${grandTotal.toFixed(2)} <span style={{ fontSize:11, fontWeight:400, color:"#999" }}>USD</span></div>
            {!isFaithAndAllenShop && estimatedShipping > 0 && (
              <div style={{ fontSize:10, color:C.muted }}>+${estimatedShipping.toFixed(2)} est. ship</div>
            )}
          </div>
          <button className="btn-primary" style={{ flex:1, padding:"13px", opacity:allValid?1:0.4, cursor:allValid?"pointer":"not-allowed" }} disabled={!allValid||submitting} onClick={handleSubmit}>
            {submitting?"Submitting…":"Submit Order"}
          </button>
        </div>
      )}

      {/* Mobile colour sheet */}
      {isMobile && mobileSheet && mobileLineData && (
        <div style={{ position:"fixed", inset:0, zIndex:300 }}>
          <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,0.4)" }} onClick={()=>setMobileSheet(null)}/>
          <div style={{ position:"absolute", bottom:0, left:0, right:0, background:C.white, borderRadius:"12px 12px 0 0", maxHeight:"82vh", display:"flex", flexDirection:"column" }}>
            <div style={{ display:"flex", justifyContent:"center", padding:"10px 0 0" }}><div style={{ width:32, height:3, borderRadius:2, background:C.border }}/></div>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 18px 10px", borderBottom:`1px solid ${C.border}` }}>
              <span style={{ fontSize:11, textTransform:"uppercase", letterSpacing:"0.1em", color:C.muted }}>Choose Shade(s) — tap to select, set qty below</span>
              <button style={{ background:"none", border:"none", fontSize:20, color:C.muted, cursor:"pointer" }} onClick={()=>setMobileSheet(null)}>×</button>
            </div>
            <div style={{ overflowY:"auto", padding:"10px 14px 16px", flex:1 }}>
              <ColorGrid colors={isFaithAndAllen ? COLORS.filter(c => c.group === "F&A") : COLORS.filter(c => c.group === "Devotion")} selected={mobileLineData.selectedColors} onToggle={code=>toggleColor(mobileSheet.lineId,code)} onClear={()=>updLine(mobileSheet.lineId,"selectedColors",[])} mobile/>
            </div>
            <div style={{ padding:"10px 14px 20px", borderTop:`1px solid ${C.border}` }}>
              <button className="btn-primary" style={{ width:"100%", padding:"13px", opacity:mobileLineData.selectedColors.length?1:0.4 }} onClick={()=>setMobileSheet(null)}>
                {mobileLineData.selectedColors.length?`Done — ${mobileLineData.selectedColors.length} shade${mobileLineData.selectedColors.length!==1?"s":""} selected`:"Done"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ─── SUB-COMPONENTS ────────────────────────────────────────────────── */
function Header({ total, mb, faShop, faWholesale, faPreorder }) {
  return (
    <header style={{ background:C.headerBg, position:"sticky", top:0, zIndex:50 }}>
      <div style={{ maxWidth:800, margin:"0 auto", padding:mb?"11px 14px":"13px 24px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <div>
          <div style={{ fontSize:mb?14:17, fontWeight:700, letterSpacing:"0.26em", color:"#FFFFFF" }}>{faShop || faWholesale ? "FAITH & ALLEN HAIR CO" : "DEVOTION SUPPLY CO."}</div>
          <div style={{ fontSize:8, letterSpacing:"0.2em", color:"#777", textTransform:"uppercase", marginTop:3 }}>{faPreorder ? "Pre-Order Form" : faShop ? "Order Form" : "Wholesale Order Form"}</div>
        </div>
        {total > 0 && (
          <div style={{ textAlign:"right" }}>
            <div style={{ fontSize:8, letterSpacing:"0.16em", color:"#777", textTransform:"uppercase" }}>Order Total</div>
            <div style={{ fontSize:mb?14:17, fontWeight:700, color:"#FFFFFF", marginTop:1 }}>${total.toFixed(2)}</div>
          </div>
        )}
      </div>
    </header>
  );
}

function Section({ num, title, note, children }) {
  return (
    <section style={{ marginBottom:4 }}>
      <div style={{ display:"flex", alignItems:"baseline", gap:10, marginBottom:14, flexWrap:"wrap" }}>
        <span style={{ fontSize:11, color:C.muted, fontWeight:600, letterSpacing:"0.1em" }}>{num}</span>
        <span style={{ fontSize:16, fontWeight:700, color:C.dark }}>{title}</span>
        {note && <span style={{ fontSize:11, color:C.muted, marginLeft:"auto" }}>{note}</span>}
      </div>
      {children}
    </section>
  );
}

function Field({ label, req, children }) {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
      <label style={{ fontSize:11, textTransform:"uppercase", letterSpacing:"0.1em", color:C.mid, fontWeight:600 }}>
        {label}{req && <span style={{ color:C.accent }}> *</span>}
      </label>
      {children}
    </div>
  );
}

function ColorGrid({ colors, selected, onToggle, onClear, mobile }) {
  const devotionSolid = colors.filter(c => c.group === "Devotion" && c.subgroup === "Solid");
  const devotionDim   = colors.filter(c => c.group === "Devotion" && c.subgroup === "Dimensional");
  const devotion      = colors.filter(c => c.group === "Devotion");
  const fa            = colors.filter(c => c.group === "F&A");
  const hasSubgroups  = devotionSolid.length > 0 || devotionDim.length > 0;
  const sectionLabel  = (text) => (
    <div style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.1em", color:C.accent, margin:"8px 0 4px" }}>{text}</div>
  );
  const renderColor = (c, i) => {
    const on = selected.includes(`${c.code}|${c.name}`);
    return (
      <div key={`${c.code}-${c.name}-${i}`} onClick={()=>onToggle(`${c.code}|${c.name}`)}
        style={{ display:"flex", alignItems:"center", gap:8, padding:mobile?"11px 6px":"5px 6px", borderRadius:3, cursor:"pointer", background:on?C.accentLight:"transparent", minHeight:mobile?42:undefined }}>
        <div style={{ width:13, height:13, border:`1.5px solid ${on?C.accent:C.border}`, borderRadius:2, background:on?C.accent:C.white, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
          {on && <svg width="9" height="7" viewBox="0 0 10 8"><path d="M1 4l3 3 5-6" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/></svg>}
        </div>
        <span style={{ fontSize:mobile?13:11 }}><strong style={{ color:C.dark }}>{c.code}</strong> <span style={{ color:C.muted }}>{c.name}</span></span>
      </div>
    );
  };
  return (
    <>
      <p style={{ fontSize:10, textTransform:"uppercase", letterSpacing:"0.1em", color:C.muted, marginBottom:4 }}>Select one or more shades</p>
      {hasSubgroups ? (<>
        {devotionSolid.length > 0 && <>{sectionLabel("Solid Shades")}<div style={{ display:"grid", gridTemplateColumns:mobile?"1fr":"1fr 1fr", gap:1, marginBottom:6 }}>{devotionSolid.map((c,i) => renderColor(c,i))}</div></>}
        {devotionDim.length > 0 && <>{sectionLabel("Dimensional Shades")}<div style={{ display:"grid", gridTemplateColumns:mobile?"1fr":"1fr 1fr", gap:1 }}>{devotionDim.map((c,i) => renderColor(c,i))}</div></>}
      </>) : (<>
        {fa.length > 0 && devotion.length > 0 && <div style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.1em", color:C.accent, marginBottom:4 }}>Devotion</div>}
        <div style={{ display:"grid", gridTemplateColumns:mobile?"1fr":"1fr 1fr", gap:1, marginBottom:fa.length>0?10:0 }}>
          {devotion.map((c,i) => renderColor(c,i))}
        </div>
      </>)}
      {fa.length > 0 && <>
        <div style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.1em", color:C.accent, marginBottom:4 }}>Faith & Allen</div>
        <div style={{ display:"grid", gridTemplateColumns:mobile?"1fr":"1fr 1fr", gap:1 }}>
          {fa.map((c,i) => renderColor(c,i))}
        </div>
      </>}
      {selected.length>0 && <button style={{ marginTop:8, background:"none", border:`1px solid ${C.border}`, borderRadius:3, padding:"6px 12px", fontSize:10, color:C.mid, cursor:"pointer", fontFamily:FONT, width:"100%", letterSpacing:"0.08em" }} onClick={onClear}>Clear selection</button>}
    </>
  );
}

/* ─── GLOBAL CSS ─────────────────────────────────────────────────────── */
const css = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #F5F5F5; }
  input[type=number]::-webkit-inner-spin-button { opacity:1; height:24px; }
  select:focus, input:focus, textarea:focus { border-color: #6B46C1 !important; box-shadow: 0 0 0 2px rgba(107,70,193,0.1); outline: none; }
  button { -webkit-tap-highlight-color: transparent; touch-action: manipulation; font-family: Helvetica Neue, Helvetica, Arial, sans-serif; }
  .btn-primary { background:#0A0A0A; border:none; border-radius:4px; color:#fff; font-size:12px; letter-spacing:0.2em; text-transform:uppercase; cursor:pointer; transition:background 0.18s; display:block; text-align:center; }
  .btn-primary:hover:not(:disabled) { background:#6B46C1; }
  .btn-ghost { background:none; border:1.5px dashed #CCCCCC; border-radius:3px; color:#666; font-size:11px; letter-spacing:0.08em; text-transform:uppercase; cursor:pointer; transition:all 0.15s; }
  .btn-ghost:hover { border-color:#6B46C1; color:#6B46C1; }
  .btn-icon { background:none; border:none; cursor:pointer; color:#999; font-size:11px; padding:4px 5px; line-height:1; }
  .btn-icon:hover { color:#333; }
`;